module.exports = __webpack_public_path__ + "img/top_option-5.6a117e1a.png";